<script lang="ts" setup>
import { ref, onMounted, onUnmounted } from 'vue' // 导入 ref 和生命周期钩子函数
import { Carousel } from '@ark-ui/vue'

import { useFetch } from '@/home/hooks/fetch';
import { useAsyncData } from '@/home/hooks/async-data';

const { $fetch } = useFetch();

const { data: imgList } = useAsyncData(
  'home:operation',
  () => $fetch('/operator/getOperatorList', { method: 'post', data: { operateType: 3 } }),
);
const index = ref(0)

// 在 setup 函数中声明一个 ref 变量来存储定时器
let timer = 0

// 创建一个函数来自动切换幻灯片
function autoPlay() {
  timer = window.setInterval(() => {
    index.value = (index.value + 1) % imgList.value.length; // 自增索引并确保在图像数组的长度内循环
  }, 3000); // 设置轮播间隔时间（单位：毫秒）
}

// 在组件挂载时启动自动播放
onMounted(() => {
  autoPlay();
});

// 在组件卸载时清除定时器
onUnmounted(() => {
  if (timer) {
    clearInterval(timer);
  }
});

const handleNextTrigger = (idx: number) => {
  clearInterval(timer); // 清除现有的定时器
  index.value = (idx + 1) % imgList.value.length
  autoPlay(); // 重新启动计时器
};

const handlePrevTrigger = (idx: number) => {
  clearInterval(timer); // 清除现有的定时器
  index.value = (idx - 1 + imgList.value.length) % imgList.value.length
  autoPlay(); // 重新启动计时器
};
</script>

<template>
  <section class="mt-20 rounded-4 shadow-[0_1px_6px_0_rgba(0,0,0,0.04)]">
    <Carousel.Root id="page-home-operation" loop v-model:index="index" class="group relative overflow-x-hidden" v-if="imgList?.length">
      <Carousel.Viewport>
        <Carousel.ItemGroup>
          <Carousel.Item v-for="(item, idx) in imgList" :key="idx" :index="idx">
            <a :href="item.jumpUrl" target="_blank" :aria-label="`${$t('home.common.carousel.jumpToUrl', { url: item.jumpUrl }) }`">
              <img :src="item.picUrl" class="block h-180 w-full rounded-4 object-cover" :alt="item.operateName">
            </a>
          </Carousel.Item>
        </Carousel.ItemGroup>
      </Carousel.Viewport>
      <Carousel.Control class="absolute top-50% h-24 w-24 translate-y--50% opacity-0 group-hover:opacity-20">
        <Carousel.PrevTrigger class="absolute left-8 top-50% h-24 w-24 cursor-pointer rounded-full bg-hex-000000/20" @click="handlePrevTrigger(index)">
          <span class="i-icons:arrow-left mx-auto block h-16 w-16"></span>
        </Carousel.PrevTrigger>
      </Carousel.Control>
      <Carousel.Control class="absolute right-0 top-50% h-24 w-24 translate-y--50% opacity-0 group-hover:opacity-20">
        <Carousel.NextTrigger class="absolute right-8 top-50% h-24 w-24 cursor-pointer rounded-full bg-hex-000000/20" @click="handleNextTrigger(index)">
          <span class="i-icons:arrow-right mx-auto block h-16 w-16"></span>
        </Carousel.NextTrigger>
      </Carousel.Control>
    </Carousel.Root>
  </section>
</template>

<style lang="scss" scoped>
</style>
